<template>
  <div class="container mt-4">
    <Layout ref="layoutRef" :selectedOption="3" />
    <h4 class="mb-4">Reporte de Sesiones por Día</h4>
    <hr>
    <div class="row mb-3">
      <div class="col-md-4">
        <label for="fechaDesde" class="form-label">Fecha Desde:</label>
        <input type="date" id="fechaDesde" v-model="fechaDesde" class="form-control">
      </div>
      <div class="col-md-4">
        <label for="fechaHasta" class="form-label">Fecha Hasta:</label>
        <input type="date" id="fechaHasta" v-model="fechaHasta" class="form-control">
      </div>
      <div class="col-md-4 d-flex align-items-end">
        <button @click="generarReporte" class="btn btn-primary">Generar Reporte</button>
      </div>
    </div>

    <div v-if="sesionesPorDia.length > 0">
      <h3 class="mt-4 mb-3">Gráfico de Sesiones por Día</h3>
<!--	  
      <apexchart type="bar" :options="chartOptions" :series="chartSeries" height="400" />
-->	  
    </div>
    <Footer />    
  </div>
</template>

<script>
import Layout from '../../../components/Layout.vue'
import Footer from '../../../components/Footer.vue'
import { ref } from 'vue';
//import VueApexCharts from 'vue3-apexcharts';
import api from "@/services/api";

export default {
  components: {
    Layout, Footer,    
//    apexchart: VueApexCharts,
  },
  mounted() {
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
  },
  setup() {
    const fechaDesde = ref('');
    const fechaHasta = ref('');
    const sesionesPorDia = ref([]);

    const chartOptions = ref({
      chart: {
        toolbar: {
          show: false,
        },
      },
      xaxis: {
        type: 'datetime',
        categories: [],
      },
      yaxis: {
        title: {
          text: 'Cantidad de Sesiones',
        },
      },
    });

    const chartSeries = ref([{ name: 'Sesiones por Día', data: [] }]);

    const generarReporte = async () => {
      if (!fechaDesde.value || !fechaHasta.value) {
        console.error('Por favor, selecciona las fechas.');
        return;
      }

      try {
        const response = await api.get('/vwsesions/groupbydia');
        sesionesPorDia.value = response.data;
        chartOptions.value.xaxis.categories = sesionesPorDia.value.map(item => item[0]);
        chartSeries.value[0].data = sesionesPorDia.value.map(item => item[1]);
      } catch (error) {
        console.error('Error al obtener los datos:', error);
      }
    };

    return {
      fechaDesde,
      fechaHasta,
      sesionesPorDia,
      chartOptions,
      chartSeries,
      generarReporte,
    };
  },
};
</script>
